// extracted by mini-css-extract-plugin
export default {"container":"Reviews-module--container--2xnf4","slide":"Reviews-module--slide--1hDx6"};